import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  TextField,
  DialogContent,
  Divider,
  Grid,
  DialogActions,
  Button,
  ListItemText,
} from "@material-ui/core";
import * as React from "react";
import { blue } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  ActionInspectionModel,
  Assign,
  AssignTo,
} from "../model/ActionedInspectionModel";
import { EmployeeModel } from "../model/EmployeeModel";
import { ActionedService } from "../services/ActionedService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  employees: any;
  company: any;
  inspection: any;
  onClose: any;
}
class AssignDialog extends React.Component<Props> {
  state = {
    selectedDate: new Date(),
    selectedTime: new Date(),
    selectedPerson: new EmployeeModel(),
  };

  handleClose = () => {
    this.props.onClose();
  };
  handleAssign = () => {
    const { selectedPerson } = this.state;
    const { inspection } = this.props;
    let momentTime = moment(this.state.selectedTime);
    let momentDate = moment(this.state.selectedDate);
    let completionMoment = moment({
      year: momentDate.year(),
      month: momentDate.month(),
      day: momentDate.date(),
      hour: momentTime.hours(),
      minute: momentTime.minutes(),
    });
    var actionedInspectionModel: ActionInspectionModel =
      new ActionInspectionModel();
    var assign = new Assign();
    var assignedTo = new AssignTo();
    assignedTo.fullName = selectedPerson.fullName;
    assignedTo.id = selectedPerson._id;
    if (selectedPerson && selectedPerson.position) {
      assignedTo.position = selectedPerson.position;
    }
    assign.assignedTo = assignedTo;
    assign.completionDate = completionMoment.toDate();
    actionedInspectionModel.assign = assign;
    actionedInspectionModel.companyId = inspection.companyId;

    inspection.headerItems.map((headerItem: any) => {
      if (headerItem.title.includes("name")) {
        headerItem.value = selectedPerson.fullName;
      }
      return null;
    });

    actionedInspectionModel.inspection = inspection;

    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService
      .addActionedInspection(actionedInspectionModel)
      .then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Assigned Successfully",
          });
          this.handleClose();
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
  };

  handleListItemClick = () => {
    this.props.onClose();
  };

  handleOnEmployeeSelected = (event: any, value: any) => {
    this.setState({
      selectedPerson: value,
    });
  };
  handleDateChange = (date: any) => {
    this.setState({ selectedDate: new Date(date) });
  };
  handleTimeChange = (time: any) => {
    this.setState({ selectedTime: new Date(time) });
  };

  render() {
    const { open, employees, dialogTitle } = this.props;
    return (
      <Dialog
        open={open}
        keepMounted={true}
        onClose={() => this.handleClose()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ width: "100%" }}>
            <Autocomplete
              id="free-solo-demo"
              freeSolo
              options={employees}
              onChange={this.handleOnEmployeeSelected}
              renderOption={(option: any) => (
                <React.Fragment>
                  <ListItemText
                    primary={option.fullName}
                    secondary={option.position}
                  />
                </React.Fragment>
              )}
              getOptionLabel={(option) => option.fullName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Assign To"
                  margin="normal"
                  variant="outlined"
                  error={
                    this.state.selectedPerson &&
                    this.state.selectedPerson.position
                      ? false
                      : true
                  }
                  helperText={
                    this.state.selectedPerson &&
                    this.state.selectedPerson.position
                      ? ""
                      : "Assigned to person required"
                  }
                  placeholder={"Search employee"}
                  style={{ width: "100%" }}
                />
              )}
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-between">
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="dd MMM yyyy"
                  margin="normal"
                  autoOk={true}
                  id="completionDate"
                  label={"Completion date"}
                  value={this.state.selectedDate}
                  onChange={(e) => this.handleDateChange(e?.toDateString())}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  margin="normal"
                  id="time-picker"
                  label="Completion time"
                  value={this.state.selectedTime}
                  onChange={(e) => this.handleTimeChange(e?.getTime())}
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.handleClose();
            }}
          >
            {"CANCEL"}
          </Button>
          <Button
            disabled={
              this.state.selectedPerson && this.state.selectedPerson.position
                ? false
                : true
            }
            type="submit"
            onClick={() => this.handleAssign()}
          >
            {"ASSIGN"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AssignDialog);
